import PlanningFilter from "#training/components/planning/PlanningFilter"
import PlanningTable from "#training/components/planning/PlanningTable"
import { AnnualPlanProvider } from "#training/contexts/contexts"
import { Box, Stack } from "@mui/material"

const Planning = () => {
	return (
		<Box>
			<AnnualPlanProvider>
				<Stack spacing={3}>
					<PlanningFilter />
					<PlanningTable />
				</Stack>
			</AnnualPlanProvider>
		</Box>
	)
}
export default Planning
